import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={36}
    height={49}
    viewBox="0 0 36 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M8.56703 42.592C11.2433 40.02 15.0228 35.875 17.4999 35.875C19.9771 35.875 23.7565 40.02 26.4329 42.592C27.9221 44.023 26.2994 45.875 23.6424 45.875H11.3574C8.70042 45.875 7.07775 44.023 8.56703 42.592Z"
      fill="#86CAA2"
    />
    <Path
      d="M17.4999 21.875C18.8392 21.875 21.2591 19.0677 23.3257 16.2895C25.0518 13.9696 23.2563 10.875 20.2894 10.875H14.7104C11.7436 10.875 9.9481 13.9696 11.6741 16.2895C13.7408 19.0677 16.1607 21.875 17.4999 21.875Z"
      fill="#86CAA2"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2.22159C0 0.994651 0.994651 0 2.22159 0H33.3239C34.5508 0 35.5455 0.994651 35.5455 2.22159C35.5455 3.44853 34.5508 4.44318 33.3239 4.44318H31.0414C30.7408 9.80013 29.3472 13.8602 27.304 17.1971C25.5221 20.1078 23.2832 22.3954 21.0771 24.4375C23.2832 26.4796 25.5221 28.7672 27.304 31.6779C29.3472 35.0147 30.7408 39.0749 31.0414 44.4318H33.3239C34.5508 44.4318 35.5455 45.4264 35.5455 46.6534C35.5455 47.8804 34.5508 48.875 33.3239 48.875H2.22159C0.994651 48.875 0 47.8804 0 46.6534C0 45.4264 0.994651 44.4318 2.22159 44.4318H4.50403C4.80457 39.0749 6.19833 35.0147 8.24133 31.6779C10.0234 28.7672 12.2623 26.4796 14.4683 24.4375C12.2623 22.3954 10.0234 20.1078 8.24133 17.1971C6.19833 13.8602 4.80457 9.80013 4.50403 4.44318H2.22159C0.994651 4.44318 0 3.44853 0 2.22159ZM26.5904 44.4318C26.3001 39.88 25.1149 36.6112 23.5147 33.9979C21.9658 31.4677 19.9841 29.4674 17.7727 27.436C15.5614 29.4674 13.5797 31.4677 12.0307 33.9979C10.4307 36.6112 9.24537 39.88 8.95506 44.4318H26.5904ZM8.95506 4.44318H26.5904C26.3001 8.99502 25.1149 12.2638 23.5147 14.8771C21.9658 17.4073 19.9841 19.4075 17.7727 21.439C15.5614 19.4075 13.5797 17.4073 12.0307 14.8771C10.4307 12.2638 9.24537 8.99502 8.95506 4.44318Z"
      fill="#CFEADA"
    />
  </Svg>
);
export default SVGComponent;
